import React, { useState } from "react";
import indicatorProducts from "../../data/IndicatorData";
import "./Indicator.css";

function IndicatorPage() {
  const [activeId, setActiveId] = useState(null);
  const [phoneModalSensor, setPhoneModalSensor] = useState(null);

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">Indicator Products</h2>

      <div className="indicator-grid">
        {indicatorProducts.map((p) => (
          <div
            key={p.id}
            className={`indicator-card ${activeId === p.id ? "active" : ""}`}
            onClick={() => setActiveId(p.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") setActiveId(p.id);
            }}
          >
            <div className="indicator-icon-wrap">
              <img src={p.image} alt={p.name} className="indicator-icon" />
            </div>

            <div className="indicator-label">{p.name}</div>
            <div className="indicator-desc">{p.description}</div>

            <div className="indicator-actions">
              <button
                className="btn btn-sm btn-price"
                onClick={(ev) => {
                  ev.stopPropagation();
                  setPhoneModalSensor(p);
                }}
              >
                Price
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Phone modal */}
      {phoneModalSensor && (
        <div
          className="phone-modal-overlay"
          onClick={() => setPhoneModalSensor(null)}
          role="presentation"
        >
          <div
            className="phone-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Contact phone"
          >
            <h4>{phoneModalSensor.name}</h4>
            <p className="phone-modal-text">
              For price & enquiries, please call us on{" "}
              <a href="tel:+918329287300" className="phone-link">
                +91-8329287300
              </a>
            </p>

            <div className="phone-modal-actions">
              <button
                className="btn btn-sm btn-close"
                onClick={() => setPhoneModalSensor(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default IndicatorPage;
